import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { connect } from 'react-redux'
import { setAccount } from '~redux/auth'
import Button from '~components/ui/Button'
import Checkbox from '~components/ui/Checkbox'
import Message from '~components/ui/Message'
import { pageView } from '~helpers/ga'

const API_URL = process.env.MIX_TOOLS_PUBLIC_API_BASE_URL
const DOTDIGITAL_ADDRESS_BOOK_ID = process.env.MIX_DOTDIGITAL_ADDRESS_BOOK_ID

class Details extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      busy: false,
      messageText: '',
      messageType: '',
      formData: {
        account: {
          first_name: this.props.account.first_name,
          last_name: this.props.account.last_name,
          email: this.props.account.email
        },
        password: {
          current_password: '',
          password: '',
          password_confirmation: ''
        },
        mail: {
          newsletter: false
        }
      }
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  componentDidMount () {
    pageView()
  }

  submitConsentPreference () {
    /* eslint-disable camelcase */
    const checked = this.state.formData.mail.newsletter
    const formData = this.state.formData.account
    const action = checked ? 'subscribe' : 'unsubscribe'
    const payload = checked ? formData : { email: formData.email }

    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/dot-digital/contacts/${action}`, payload, {
        headers: { 'X-Address-Book-ID': DOTDIGITAL_ADDRESS_BOOK_ID }
      }).then(response => resolve(response))
        .catch((e) => reject(e))
    })
  }

  handleInputChange (event, form) {
    const target = event.target
    const name = target.name
    let value = target.value

    if (target.type === 'checkbox') {
      value = target.checked
    }

    this.setState({
      formData: {
        ...this.state.formData,
        [form]: {
          ...this.state.formData[form],
          [name]: value
        }
      }
    })
  }

  handleFormSubmit (event, form) {
    event.preventDefault()

    if (form === 'account') {
      return this.submitAccountForm()
    }

    if (form === 'password') {
      return this.submitPasswordForm()
    }

    if (form === 'mail') {
      return this.submitMailForm()
    }
  }

  setMessage (type, message) {
    this.setState({
      messageType: type,
      messageText: message
    })

    setTimeout(() => {
      this.setState({
        messageType: ''
      })
    }, 5000)
  }

  submitAccountForm () {
    if (this.state.busy) {
      return
    }

    this.setState({
      busy: true
    })

    axios.put('/api/account', this.state.formData.account)
      .then(response => {
        this.props.setAccount(response.data)
        this.setMessage('success', 'Your account has been updated')
      })
      .catch(e => {
        this.setMessage('error', 'There was an error updating your account details')
      })
      .finally(() => {
        this.setState({
          busy: false
        })
      })
  }

  submitPasswordForm () {
    if (this.state.busy) {
      return
    }

    this.setState({
      busy: true
    })

    axios.put('/api/account/password', this.state.formData.password)
      .then(response => {
        this.props.setAccount(response.data)

        this.setState({
          formData: {
            ...this.state.formData,
            password: {
              current_password: '',
              password: '',
              password_confirmation: ''
            }
          }
        })

        this.setMessage('success', 'Your password has been updated')
      })
      .catch(e => {
        this.setMessage('error', 'There was an error updating your password')
      })
      .finally(() => {
        this.setState({
          busy: false
        })
      })
  }

  submitMailForm () {
    if (this.state.busy) return
    this.setState({ busy: true })

    this.submitConsentPreference()
      .then(() => {
        this.setMessage('success', 'Your preferences has been updated')
      })
      .catch(e => {
        this.setMessage('error', 'There was an error updating your preferences')
      })
      .finally(() => this.setState({ busy: false }))
  }

  render () {
    return (
      <>
        {this.state.messageText &&
          <Message
            messageType={this.state.messageType}
            messageText={this.state.messageText}
          />}

        <section className="mt-10 mb-10 xl:mt-0 xl:mb-20">
          <h3 className="pb-4 text-left border-b text-md border-coral">
            Details
          </h3>

          <form onSubmit={e => { this.handleFormSubmit(e, 'account') }}>

            <div className="w-full mt-3 lg:w-1/2 xl:w-1/3">
              <label className="inline-block mt-4">
                First name
              </label>
              <input name="first_name" type="text" required value={this.state.formData.account.first_name} onChange={e => { this.handleInputChange(e, 'account') }} className="relative block w-full p-4 mt-2 border rounded-md appearance-none placeholder-lightCharcoal text-charcoal border-lightCharcoal focus:border-charcoal focus:outline-none focus:z-10" placeholder="First name" />
            </div>

            <div className="w-full mt-3 lg:w-1/2 xl:w-1/3">
              <label className="inline-block mt-4">
                Last name
              </label>
              <input name="last_name" type="text" required value={this.state.formData.account.last_name} onChange={e => { this.handleInputChange(e, 'account') }} className="relative block w-full p-4 mt-2 border rounded-md appearance-none placeholder-lightCharcoal text-charcoal border-lightCharcoal focus:border-charcoal focus:outline-none focus:z-10" placeholder="Last name" />
            </div>

            <div className="w-full mt-3 lg:w-1/2 xl:w-1/3">
              <label className="inline-block mt-4">
                Email address
              </label>
              <input name="email" type="email" required value={this.state.formData.account.email} onChange={e => { this.handleInputChange(e, 'account') }} className="relative block w-full p-4 mt-2 border rounded-md appearance-none placeholder-lightCharcoal text-charcoal border-lightCharcoal focus:border-charcoal focus:outline-none focus:z-10" placeholder="Email address" />
            </div>

            <div className="mt-6">
              <Button type="submit" className="w-auto mt-4">
                Update details
              </Button>
            </div>

          </form>

          <h3 className="pb-4 mt-20 text-left border-b text-md border-coral">
            Change Password
          </h3>

          <form onSubmit={e => { this.handleFormSubmit(e, 'password') }}>
            <div className="w-full mt-3 lg:w-2/3 xl:w-1/3">
              <label className="inline-block mt-4">
                Current password
              </label>
              <input name="current_password" type="password" required value={this.state.formData.password.current_password} onChange={e => { this.handleInputChange(e, 'password') }} className="relative block w-full p-4 mt-2 border rounded-md appearance-none placeholder-lightCharcoal text-charcoal border-lightCharcoal focus:border-charcoal focus:outline-none focus:z-10" placeholder="Current password" />
            </div>

            <div className="w-full mt-3 lg:w-1/2 xl:w-1/3">
              <label className="inline-block mt-4">
                New password
              </label>
              <input name="password" type="password" required value={this.state.formData.password.password} onChange={e => { this.handleInputChange(e, 'password') }} className="relative block w-full p-4 mt-2 border rounded-md appearance-none placeholder-lightCharcoal text-charcoal border-lightCharcoal focus:border-charcoal focus:outline-none focus:z-10" placeholder="New password" />
            </div>

            <div className="w-full mt-3 lg:w-1/2 xl:w-1/3">
              <label className="inline-block mt-4">
                Confirm new password
              </label>
              <input name="password_confirmation" type="password" required value={this.state.formData.password.password_confirmation} onChange={e => { this.handleInputChange(e, 'password') }} className="relative block w-full p-4 mt-2 border rounded-md appearance-none placeholder-lightCharcoal text-charcoal border-lightCharcoal focus:border-charcoal focus:outline-none focus:z-10" placeholder="Confirm new password" />
            </div>

            <div className="mt-6">
              <Button type="submit" className="w-auto mt-4">
                Change password
              </Button>
            </div>
          </form>

          <h3 className="pb-4 mt-20 text-left border-b text-md border-coral">
            Communication preferences
          </h3>

          <form onSubmit={e => { this.handleFormSubmit(e, 'mail') }}>
            <div className="relative flex flex-col items-start w-full mt-7 md:flex-row lg:w-2/3 xl:w-1/2">
              {this.state.formData.newsletter}

              <Checkbox
                name="newsletter"
                value="1"
                id="newsletter"
                checked={this.state.formData.mail.newsletter}
                onChange={(e) => this.handleInputChange(e, 'mail')}
                className="mr-4"
              />

              <label htmlFor="newsletter" className="block mt-3 cursor-pointer md:mt-0">
                <strong>
                  Panache business  monthly email newsletter
                </strong>

                {this.state.formData.mail.newsletter && (
                  <span className="block clear-both">
                    {'If you don\'t fancy getting updates from us that are exclusive to our trade Partners? Untick this box. Are you sure? Don\'t worry, there won\'t be a new email in your inbox every day, we only send out the important stuff...Like business updates, exclusive trade incentive offers, information about our styles to help you get to know the product - especially if it\'s new! And other useful bits like order cut off dates for the coming season. Hope to have you with us!'}
                  </span>
                )}

                {!this.state.formData.mail.newsletter && (
                  <span className="block clear-both">
                    {'Fancy getting updates from us that are exclusive to our trade Partners? Tick this box. Don\'t worry, there won\'t be a new email in your inbox every day, we only send out the important stuff...Like business updates, exclusive trade incentive offers, information about our styles to help you get to know the product - especially if it\'s new! And other useful bits like order cut off dates for the coming season. Hope to have you with us!'}
                  </span>
                )}
              </label>
            </div>

            <div className="mt-6">
              <Button type="submit" className="w-auto mt-4">
                Save preferences
              </Button>
            </div>
          </form>
        </section>
      </>
    )
  }
}

Details.propTypes = {
  account: PropTypes.object,
  setAccount: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    account: state.auth.account
  }
}

const mapDispatchToProps = { setAccount }

export default connect(mapStateToProps, mapDispatchToProps)(Details)
